import { createFileRoute } from "@tanstack/react-router";
import { SmartLinkListPage, type SmartLinkTab } from "../../../components/system/SmartLinkListPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/smart-link/")({
  beforeLoad: requireSuperAdmin(),
  validateSearch: (search: Record<string, unknown>): { tab?: SmartLinkTab } =>
    search.tab === "products" ? { tab: "products" } : {},
  component: SmartLinkRoute,
});

function SmartLinkRoute() {
  const { tab } = Route.useSearch();
  return <SmartLinkListPage tab={tab ?? "users"} />;
}
